import React, { useState } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import Arrow from '../components/Icons/Arrow';
import { handleregionapollo } from '../functions/handleregionapollo';
import { GET_ABOUT_PAGES } from '../gqlStrings/queries/getPages';
export default function Privacy({ post }: { post: any }) {
  const router = useRouter();
  const [open, setOpen] = useState('');
  if (router.isFallback) {
    return (
      <div className="h-[70vh] items-center justify-center flex">
        Loading...
      </div>
    );
  }

  const htmlDoc = parse(post.content, {
    replace: (domnode) => {
      const { attribs, children }: any = domnode;
      if (attribs && attribs?.class === 'wp-block-columns') {
        const header = children[0].next.children[0].next.children[0].data;
        return (
          <>
            <div
              onClick={() => {
                if (open == header) {
                  setOpen('');
                } else {
                  setOpen(header);
                }
              }}
              className="w-full mb-5 max-w-screen-md mx-auto select-none cursor-pointer items-center leading-none flex justify-between bg-brand-grey175 py-5 px-6 rounded-md text-[18px] font-medium underline font-sans hover:bg-[#cdcfcd]">
              <span>{header}</span>
              <span
                className={
                  open == header
                    ? 'transform -rotate-180 transition-transform duration-200'
                    : 'transform rotate-0 transition-transform duration-200'
                }>
                <Arrow color="black" />
              </span>
            </div>
            {open == header && (
              <div className={'text-base max-w-screen-md mx-auto px-6 pb-5 '}>
                {children && domToReact(children.slice(3, children.length - 1))}
              </div>
            )}
          </>
        );
      }
      if (attribs && attribs?.id === 'replaceleft') {
        return (
          <div className="w-[603px] h-[402px] relative lgx:mx-auto mdx:w-full mdx:h-[200px]">
            <Image
              src={children[0].attribs.src}
              layout="fill"
              objectFit="cover"
              quality={90}
              alt={children[0].attribs.alt}
              priority
            />
          </div>
        );
      }
      if (attribs && attribs?.id === 'replacefull') {
        return (
          <div className="w-full h-[290px] mdx:h-[200px] max-w-[1100px] relative mt-20 mb-10 mx-auto">
            <Image
              src={children[0].attribs.src}
              layout="fill"
              objectFit="cover"
              quality={100}
              alt={children[0].attribs.alt}
              priority
            />
          </div>
        );
      }
      return;
    }
  });
  return (
    <div className="pt-12 px-12  mdx:px-4 mdx:pt-8 w-full">
      <Head>
        <title>Privacy Policy - Dresden</title>
        <meta name="description" content="Privacy Policy Your privacy is important to us, so we acknowledge and are committed to protecting your privacy, as well as that of other third parties who provide personal data to us. The following Privacy Policy outlines the information we collect about you, how we use the information and the choices you have to review… Continue reading Privacy Policy" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Privacy Policy" />
        <meta property="og:description" content="Privacy Policy Your privacy is important to us, so we acknowledge and are committed to protecting your privacy, as well as that of other third parties who provide personal data to us. The following Privacy Policy outlines the information we collect about you, how we use the information and the choices you have to review… Continue reading Privacy Policy" />
        <meta property="og:site_name" content="Dresden" />
      </Head>
      <div className="mx-auto max-w-screen-2xl relative font-sans leading-[1.7] text-brand-black75">
        {htmlDoc}
      </div>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const res = await handleregionapollo(locale).query({
    query: GET_ABOUT_PAGES,
    variables: {
      id: 'privacy',
      idType: 'SLUG'
    }
  });
  if (res.data.post.categories.nodes[0].name != 'privacy') {
    return {
      notFound: true
    };
  }

  return {
    props: { post: res.data.post }
  };
};
